import { decamelize } from 'humps';

export type StringifyUrlQueryOptions = {
  decamelize?: boolean;
};

const buildParams =
  (options: StringifyUrlQueryOptions) =>
  (obj: any, prefix = '', result: [string, string][] = []) => {
    const prepareKey = (key: string) =>
      options.decamelize ? decamelize(key) : key;

    if (Array.isArray(obj)) {
      obj.forEach(item => {
        buildParams(options)(item, `${prefix}[]`, result);
      });
    } else if (typeof obj === 'object' && obj !== null) {
      Object.entries(obj).forEach(([key, value]) => {
        const decamelizedKey = prepareKey(key);
        const newPrefix = prefix
          ? `${prefix}[${decamelizedKey}]`
          : decamelizedKey;
        buildParams(options)(value, newPrefix, result);
      });
    } else if (obj !== null && obj !== undefined && obj !== '') {
      result.push([prepareKey(prefix), String(obj)]);
    }
    return result;
  };

export const stringifyUrlQuery = (
  params: {
    [key: string]:
      | string
      | number
      | (string | number)[]
      | Record<string, any>
      | null
      | undefined;
  },
  options: StringifyUrlQueryOptions = {},
) => {
  const optionsWithDefaults = {
    decamelize: true,
    ...options,
  };

  const pairs = buildParams(optionsWithDefaults)(params);
  if (pairs.length === 0) return '';
  const query = pairs
    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
    .join('&');
  return `?${query}`;
};
